// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ctn_full-screen[data-v-6fde4eb1]{height:100vh;width:100%;flex-direction:column;justify-content:space-between}.ctn[data-v-6fde4eb1],.ctn_full-screen[data-v-6fde4eb1]{display:flex;align-items:center}.ctn[data-v-6fde4eb1]{flex-wrap:wrap;max-width:700px}.center[data-v-6fde4eb1],.ctn[data-v-6fde4eb1]{justify-content:center}.center[data-v-6fde4eb1]{display:flex}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
